/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from 'styled-components';
import { Modal } from 'antd';

export const MealPlanCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  .preview-image {
    overflow: hidden;
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  .menu-plan-name {
    padding-top: 16px;
    padding-bottom: 8px;
    font-size: 18px;
    font-weight: 700;
  }
  input[type='file'] {
    display: none;
  }
`;

export const MealPlanThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: cente;
  width: 100%;
  height: 200px;
  background: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  pointer-events: auto;

  .non-image-description {
    width: 100%;
    text-align: center;

    .image-guide-description {
      font-size: 12px;
      color: #acacac;
    }
  }
`;

export const MealPlanButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  margin-top: auto;

  button {
    width: 100%;
    height: 34px;
    padding: 0;
    border-radius: 6px;
    font-size: 14px;
  }
  button.edit-button {
    background: #333;
    border-color: #333;
  }
`;

// ##### MealPlanAdd, MealPlanEdit #####

export const MealPlanFormContainer = styled.div`
  .title {
    padding-bottom: 8px;
    font-size: 18px;
    font-weight: 700;
  }
  .title:not(:first-child) {
    padding-top: 16px;
  }

  .ant-col.ant-form-item-label {
    padding: 8px 8px 0px 0px;
    width: 110px;
    text-align: left;
  }
  .ant-radio-group.ant-radio-group-outline {
    display: flex;
    gap: 16px;

    .ant-radio-button-wrapper {
      width: 200px;
      border-left: 1px solid;
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;

      &:not(.ant-radio-button-wrapper-checked) {
        border: 1px solid #d9d9d9;
      }
      &:before {
        display: none;
      }
    }
  }
  .ant-form-item-control-input {
    .ant-form-item-control-input-content {
      input.ant-input,
      input.ant-input.ant-input-status-error {
        width: 100%;
        max-width: 600px;
        height: 40px;
        padding: 0px 10px;
        font-size: 14px;
        border: 1px solid #d9d9d9;
      }
    }
  }
  .ant-picker {
    width: 200px;
    height: 40px;
    border-radius: 5px;

    .ant-picker-input > input {
      font-size: 14px;
    }
  }

  .item-add-button {
    width: 100%;
    height: 40px;
    margin: 16px 0px;
    border-radius: 6px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  min-width: 200px;
  min-height: 200px;
  border: 2px dashed #e2e2e2;
  border-radius: 5px;
  cursor: pointer;

  .container-center {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #999999;
    font-weight: 400;
  }
  .preview-image {
    width: 400px;
    height: 300px;
    object-fit: cover;
  }
  .anticon-close-circle {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 20px;
    color: #666666;
  }

  input[type='file'] {
    display: none;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: baseline;

  .switch-label {
    padding-left: 24px;
    font-size: 12px;
    color: #999999;
  }
`;

export const TableWrapper = styled.div`
  .ant-table-container {
    .ant-table-content {
      .ant-table-cell {
        input.ant-input {
          height: 40px;
          padding: 0px 12px;
          font-size: 14px;
        }
      }
    }
  }
`;

export const StyledModal = styled(Modal)`
  // 식단표 구성
  &.nutrition-modal.ant-modal .ant-modal-body {
    max-height: 500px;
    overflow-y: scroll;
  }

  .ant-modal-content {
    overflow: hidden;
    border-radius: 16px;

    .meal-plan-name {
      padding-bottom: 4px;
      font-size: 16px;
      font-weight: 700;
    }
    .nutrition > div {
      display: flex;
      justify-content: space-between;
    }
    .meal-plan-item {
      padding-bottom: 2px;
      .meal-plan-item-name {
        display: flex;
        justify-content: space-between;
      }
      .item-nutrition {
        padding-left: 4px;
        line-height: 18px;
      }
    }

    .font-bold {
      padding: 4px 0px;
      font-weight: 700;
    }
    .font-xs {
      font-size: 12px;
      line-height: 24px;
    }
    .basic-sd-gray {
      color: #afb3b8;
    }
  }
`;

export const ExcelUploadInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100px;
  border: 2px dashed rgb(226, 226, 226);
  border-radius: 5px;
  cursor: pointer;
  color: #999999;

  .anticon-upload {
    font-size: 32px;
    margin-bottom: 4px;
  }
  .file-name {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 12px);
    height: 100%;
    margin: 6px;
    background: #ededed;
    border-radius: 4px;
  }
  .anticon-close-circle {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 18px;
  }
`;

export const FileUploadModalFooter = styled.div`
  .ant-btn {
    min-width: 80px;
    border-radius: 5px;
    font-size: 14px;
  }
`;
export const FileUploadModalContent = styled.div`
  ul {
    font-size: 12px;
    color: #999999;
    padding-left: 14px;
  }

  input[type='file'] {
    display: none;
  }
`;
